// @core/api/endpoints/secret/delete_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Delete access policy
 * Deletes an access policy. Actors that had this policy will lose the associated capabilities.
 */
export async function DeletePolicy(
  policy_name: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/policies/:policy_name`;
  requestPath = requestPath.replace(':policy_name', encodeURIComponent(policy_name));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
